import Transfer from 'bee-transfer'

export default Transfer
